module.exports = __webpack_public_path__ + "static/media/logo-bms.2ce52e4f.png";